module.exports = function(h, row) {
    return 'RM' + row.revenue;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/coupon/revenue.jsx